export interface MediaModel {
	customerWmsId: string;
	type: MediaType;
	filename: string;
	filetype: string;
	filesize: number;
	orgFilename: string;
	patient?: string; 		//ObjectID of mongoDB reference
	treatment?: string;  	//ObjectID of mongoDB reference
	ticket?: string; 		//ObjectID of mongoDB reference
	lastModified: Date;
	created: Date;
	expiresAt?: Date;
	visibilityScope: MediaVisibilityScope;
	uploadType?: AnamneseFunctionALUploadType | AnamneseUploadType;

	/** @deprecated Legacy since 2.5.0, do not use. Omitted in documents since v3.0.0. Use 'customerWmsId' instead. */
	uid?: number;
	/** @deprecated Legacy since 2.0.0, do not use. */
	order?: string;
	//exclusive mongodb fields
	_id?: string;			//ObjectID of mongodb entry
}

export enum MediaType
{
	User = 0,
	Admin = 1
}

export enum MediaVisibilityScope{
	PUBLIC = "public",
	INTERN = "intern",
	ADMIN = "admin"
}

export enum  UPL_ERROR {
	TOO_MANY = 0,
	INVALID = 1,
	TOO_LARGE = 2,
	TRANSFER = 3,
	EMPTY = 4,
	DUPLICATE = 5
}

export enum UPL_STATE {
	PERCENT = 0,
	COMPLETED = 1,
	ERROR = 2
}

export enum AnamneseUploadType {
	UJ = 'uj',
	LJ = 'lj',
	EXTRAORAL_FRONT_MOUTH_CLOSED = 'extraoral_front_mouth_closed',
	EXTRAORAL_FRONT_SMILE = 'extraoral_front_smile',
	EXTRAORAL_RIGHT = 'extraoral_right',
	INTRAORAL_FRONT = 'intraoral_front',
	INTRAORAL_UJ = 'intraoral_uj',
	INTRAORAL_LJ = 'intraoral_lj',
	INTRAORAL_RIGHT = 'intraoral_right',
	INTRAORAL_LEFT = 'intraoral_left',
	MISC_DVT = 'misc_dvt'
}

export const ANAMNESE_ADDITIONAL_UPLOAD_TYPES: AnamneseUploadType[] = [
	AnamneseUploadType.EXTRAORAL_FRONT_MOUTH_CLOSED,
	AnamneseUploadType.EXTRAORAL_FRONT_SMILE,
	AnamneseUploadType.EXTRAORAL_RIGHT,
	AnamneseUploadType.INTRAORAL_FRONT,
	AnamneseUploadType.INTRAORAL_UJ,
	AnamneseUploadType.INTRAORAL_LJ,
	AnamneseUploadType.INTRAORAL_RIGHT,
	AnamneseUploadType.INTRAORAL_LEFT,
	AnamneseUploadType.MISC_DVT
];

export enum AnamneseFunctionALUploadType {
	UJ_BITE = 'uj_bite',
	LJ_BITE = 'lj_bite',
	UJ_REGISTRATION = 'uj_registration',
	LJ_REGISTRATION = 'lj_registration',
	EXTRAORAL_FRONT_MOUTH_CLOSED = 'extraoral_front_mouth_closed',
	EXTRAORAL_FRONT_MOUTH_OPEN = 'extraoral_front_mouth_open',
	EXTRAORAL_FRONT_SMILE = 'extraoral_front_smile',
	EXTRAORAL_RIGHT = 'extraoral_right',
	INTRAORAL_FRONT = 'intraoral_front',
	INTRAORAL_UJ = 'intraoral_uj',
	INTRAORAL_LJ = 'intraoral_lj',
	INTRAORAL_RIGHT = 'intraoral_right',
	INTRAORAL_LEFT = 'intraoral_left',
	MISC_OPG = 'misc_opg',
	MISC_FRS = 'misc_frs'
}

export enum DefaultAllowedExtensions {
	STL = 'stl',
	PLY = 'ply',
	PDF = 'pdf',
	PNG = 'png',
	JPG = 'jpg',
	JPEG = 'jpeg'
}
